import { render, staticRenderFns } from "./RetailSettings.template.vue?vue&type=template&id=37e25b6a&scoped=true&"
var script = {}
import style0 from "./RetailSettings.template.vue?vue&type=style&index=0&id=37e25b6a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e25b6a",
  null
  
)

export default component.exports